import React from 'react';
import { childConnectionDetailsLabels } from '../../../../../../constants/connections-labels.constants';
import DefaultButton from '../../../../../global/default-button/default-button';
import { FormattedMessage } from 'react-intl';
import { JOIN_MEETING } from '../../../_connections/connections.texts';
import TextWithCopyBtn from '../_text-with-copy-btn/text-with-copy-btn';
import { BaseConnectionDetailsPopoverContentProps } from './types';

export const PanelistLinkConnectionDetailsPopoverContent = (props: BaseConnectionDetailsPopoverContentProps): JSX.Element => {
    const { connection, onLinkClick, onCopyBtnClick } = props;
    const {
        cancelled,
        connectionLink,
        connectionId,
        attendeeEmail,
        participantId,
        attendeeId
    } = connection;

    const labels = childConnectionDetailsLabels();

    return (
        <>
            <div className='connection-list__header'>
                <DefaultButton
                    className='prominent-button'
                    disabled={!connectionLink || cancelled}
                    text={<FormattedMessage {...JOIN_MEETING} />}
                    onClick={() => onLinkClick(connectionLink)}
                />
            </div>
            {connectionLink && <div className='connection-list__field'>{labels.CONNECTION_LINK()}:<br />
                <TextWithCopyBtn message={connectionLink} handleCopyClick={onCopyBtnClick} />
            </div>}
            {participantId && <div className='connection-list__field'>{labels.PARTICIPANT_ID()}:<br />
                <TextWithCopyBtn message={participantId} handleCopyClick={onCopyBtnClick} />
            </div>}
            {attendeeId && <div className='connection-list__field'>{labels.ATTENDEE_ID()}:<br />
                <TextWithCopyBtn message={attendeeId.toString()} handleCopyClick={onCopyBtnClick} />
            </div>}
            {attendeeEmail && <div className='connection-list__field'>{labels.ATTENDEE_EMAIL()}:<br />
                <TextWithCopyBtn message={attendeeEmail} handleCopyClick={onCopyBtnClick} />
            </div>}
            {connectionId && <div className='connection-list__field'>{labels.WEBINAR_ID()}:<br />
                <TextWithCopyBtn message={connectionId} handleCopyClick={onCopyBtnClick} />
            </div>}
        </>
    );
};
